import * as rxMapActions from './rxMapActions'
import { FormControl } from '@atd/rui-base.mui.form-control'
import { InputLabel } from '@atd/rui-base.mui.input-label'
import { MenuItem } from '@atd/rui-base.mui.menu-item'
import { Select } from '@atd/rui-base.mui.select'

import AddIcon from '@mui/icons-material/Add'
import { Button } from '@atd/rui-base.mui.button'
import { RavenThemeScope } from '../ravenV5Theme'
import { Dialog } from '@atd/rui-base.mui.dialog'
import { DialogActions } from '@atd/rui-base.mui.dialog-actions'
import { DialogContent } from '@atd/rui-base.mui.dialog-content'
import React from 'react'
import RxMapEdit from './rxMapEdit'
import RxMapSearch from './rxMapSearch'
import SearchIcon from '@mui/icons-material/Search'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

const styles = {
    newRxButtonSize: {
        minWidth: '11vw',
        maxWidth: '25vw',
    },
}

function mapStateToProps(state, ownProps) {
    return {
        rxFiles: state.product.rxFiles,
        currentProducts: state.product.currentProducts,
        rxMapEditDialog: state.product.rxMapEditDialog,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(rxMapActions, dispatch),
    }
}

const HIGH_SHAPE_LIMIT = 50000
class OneProductRx extends React.Component {
    static defaultProps = {
        data: {},
        rateUnits: [],
        setProductProperty: () => { console.log('OneProductRx::setProductProperty Default') },
        disabled: false,
    }

    state = {
        rxMap: null,
        rxSearchOpen: false,
        rxUploadOpen: false,
        warningDialogOpen: false,
    }


    handleRxUploadRequest = () => {
        this.setState({rxUploadOpen: true})
        this.props.setRxMapEditDialog({open: true, productId: this.props.data.id})
    }
    handleRxSearchRequest = () => {
        this.setState({rxSearchOpen: true})
    }
    handleWarning = (open = false, rxMap = null) => {
        this.setState({
            warningDialogOpen: open,
            rxMap,
        })
    }
    closeDialogs = () => {
        this.setState({
            rxSearchOpen: false,
            rxUploadOpen: false,
            warningDialogOpen: false,
        })
    }
    switchToNewRx = () => {
        this.closeDialogs()
        this.handleRxUploadRequest()
    }
    renderHighShapeWarning = () => {
        if (!this.state.warningDialogOpen) return

        let rxMapName = ''
        if (this.state.rxMap && this.state.rxMap.clientFileName) { rxMapName = this.state.rxMap.clientFileName }

        return (
            <Dialog
                open={true}
                onClose={(_, reason) => { if (reason !== 'backdropClick') this.closeDialogs() }}
                name="shapeWarningDialog"
            >
                <DialogContent>
                    <h3> High Shape Count Detected</h3>
                    <p> RxMap {rxMapName} contains a high number of shapes. Rendering it within the map has been disabled. Field Computer performance may not be ideal. </p>
                </DialogContent>
                <DialogActions>
                    <Button variant="text" color="primary" onClick={this.closeDialogs} name="okPolygonWarning">Ok</Button>
                </DialogActions>
            </Dialog>
        )
    }
    handleRxSelect = (event, index, value) => {
        if (value != 0) {
            const rxMap = this.props.rxFiles.find(file => file.id === value)
            this.onRxSelect(rxMap)
        }
    }
    onRxSelect = (rxMap) => {
        this.setState({rxMap})
        this.closeDialogs()
        if (rxMap.shapes && rxMap.shapes.features && rxMap.shapes.features.length > HIGH_SHAPE_LIMIT) {
            this.setState({
                warningDialogOpen: true,
                highShapeCount: true,
            })
        }
        else {
            this.setState({highShapeCount: false})
        }
        this.props.setProductProperty(this.props.data.id, 'rxMapId', rxMap.id)
        this.props.setProductProperty(this.props.data.id, 'rxMapName', rxMap.clientFileName)
        this.props.setProductProperty(this.props.data.id, 'rxMapGuid', rxMap.guid)
        if (rxMap.columns.length === 1) {
            this.props.setProductProperty(this.props.data.id, 'rxMapColumnId', rxMap.columns[0])
        }
        else {
            this.props.setProductProperty(this.props.data.id, 'rxMapColumnId', '')
        }
    }
    handleColumn = (event, index, value) => {
        this.props.setProductProperty(this.props.data.id, 'rxMapColumnId', value)
    }
    handleMapUnit = (event, index, value) => {
        this.props.setProductProperty(this.props.data.id, 'rxMapUnit', value)
    }

    createRxMapDropDownList = () => {
        const addButton = (
            <MenuItem value={0} key={'none'} label={'Select an RxMap'} name="newRx">
                <RavenThemeScope>
                    <div className="dropdownButtonRow" style={{ display: 'inline' }}>
                        <Button variant="contained" style={{ ...styles.newRxButtonSize, marginRight: 8 }} color="primary" className="dropdownButton" onClick={this.handleRxUploadRequest} name="addRxButton"><AddIcon htmlColor="white" /></Button>
                        <Button variant="contained" style={styles.newRxButtonSize} color="primary" className="dropdownButton" onClick={this.handleRxSearchRequest} name="searchRxButton"><SearchIcon htmlColor="white" /></Button>
                    </div>
                </RavenThemeScope>
            </MenuItem>
        )

        return [
            addButton,
            ...this.props.rxFiles.map((data) => {
                return (<MenuItem value={data.id} key={data.id} name="data.id">{data.clientFileName}</MenuItem>)
            }),
        ]
    }
    createRxMapColumnDropDownList = () => {
        const selectedMap = this.props.rxFiles.find(map => map.id === this.props.data.rxMapId) || {}
        const columns = []

        // If we don't have meta information, request a reparse
        if (selectedMap.id &&
            (!selectedMap.columns.length ||
             !selectedMap.shapes ||
             !selectedMap.shapes.features ||
             !selectedMap.shapes.features.length ||
             !selectedMap.boundingBox.length
            )
        ) {
            this.props.fetchRxMapMeta(selectedMap.id)
        }
        if (selectedMap.columns) {
            columns.push(
                ...selectedMap.columns.map((data, i) => {
                    return <MenuItem value={data} key={i} name={data}>{data}</MenuItem>
                }),
            )
        }

        return columns
    }
    renderRxSearch = () => {
        if (!this.state.rxSearchOpen) return

        return (
            <RxMapSearch
                onCancel={this.closeDialogs}
                onNewRxRequest={this.switchToNewRx}
                onRxSelect={this.onRxSelect}
                initRxMapId={this.state.rxMap ? this.state.rxMap.id : null}
            />
        )
    }
    renderRxUpload = () => {
        if (!this.state.rxUploadOpen) return

        return (
            <RxMapEdit
                onCancel={this.closeDialogs}
                onRxUpload={this.onRxSelect}
                open={this.props.rxMapEditDialog.open}
            />
        )
    }
    render() {
        const selectedMap = this.props.rxFiles.find(map => map.id === this.props.data.rxMapId) || {}
        const columnLoaded = (selectedMap.columns || []).includes(this.props.data.rxMapColumnId)
        const rxMapColumnValue = columnLoaded ? this.props.data.rxMapColumnId : ''

        return (
            <div>
                <FormControl variant="standard" margin="normal" className="selectField" disabled={this.props.disabled} error={!this.props.data.rxMapId || this.state.highShapeCount}>
                    <InputLabel>Rx Map</InputLabel>
                    <Select
                        value={this.props.data.rxMapId > 0 ? this.props.data.rxMapId : ''}
                        onChange={(event) => this.handleRxSelect(event, null, event.target.value)}
                        label="Rx Map"
                        name="rxMapSelect"
                    >
                        {this.createRxMapDropDownList()}
                    </Select>
                </FormControl>
                <FormControl variant="standard" margin="normal" className="selectField" disabled={this.props.disabled} error={!this.props.data.rxMapColumnId}>
                    <InputLabel>Map Column</InputLabel>
                    <Select
                        value={rxMapColumnValue}
                        onChange={(event) => this.handleColumn(event, null, event.target.value)}
                        label="Map Column"
                        name="rxMapColumn"
                    >
                        {this.createRxMapColumnDropDownList()}
                    </Select>
                </FormControl>
                <FormControl variant="standard" margin="normal" className="selectField" disabled={this.props.disabled} error={!this.props.data.rxMapUnit}>
                    <InputLabel>Map Unit</InputLabel>
                    <Select
                        value={this.props.data.rxMapUnit || ''}
                        onChange={(event) => this.handleMapUnit(event, null, event.target.value)}
                        label="Map Unit"
                        name="rxMapUnit"
                    >
                        {this.props.rateUnits}
                    </Select>
                </FormControl>
                {this.renderRxSearch()}
                {this.renderRxUpload()}
                {this.renderHighShapeWarning()}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OneProductRx)
